import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OrderByType } from 'config/constants/search.constants';
import { DEFAULT_MY_PURCHASE_PAGE_SIZE } from 'config/utils/globals.util';
import { Purchase, StorePurchases } from 'store/models/order.model';

const initialState: StorePurchases = {
  purchases: [],
  isFetching: false,
  totalPurchases: 0,
  limit: DEFAULT_MY_PURCHASE_PAGE_SIZE,
  orderBy: OrderByType.DESC,
  page: 1,
};

type refreshPurchasesAndTotalPurchasesPayload = Pick<StorePurchases, 'purchases' | 'totalPurchases'>;

export const purchaseSlice = createSlice({
  name: 'purchase',
  initialState,
  reducers: {
    refreshOrderBy: (state, action: PayloadAction<OrderByType>) => {
      state.orderBy = action.payload;
      return state;
    },
    refreshPageNumber: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
      return state;
    },
    refreshUserPurchases: (state, action: PayloadAction<refreshPurchasesAndTotalPurchasesPayload>) => {
      state.purchases = action.payload.purchases;
      state.totalPurchases = action.payload.totalPurchases;
      return state;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
      return state;
    },
    refreshItem: (state, action: PayloadAction<Purchase>) => {
      state.item = action.payload;
      return state;
    },
    refreshPurchaseStore: (state, action: PayloadAction<StorePurchases>) => {
      state = { ...state, ...action.payload };
      return state;
    },
    resetPurchaseStore: () => initialState,
  },
});

export const PurchaseSlice = purchaseSlice.actions;
export default purchaseSlice.reducer;
